import { YhcEFInputOneKazaiTypeDataObject } from './YhcEFInputOneKazaiTypeDataObject'
import { YhcEFInputOneKazaiTypeDataObjectForKaguidoOption } from './YhcEFInputOneKazaiTypeDataObjectForKaguidoOption'

export type YhcZipCodePrefectureType = {
  zipCode: string
  prefecture: string
  areaMessage: string
}

/**
 * YhcGA4EventSender
 */
export class YhcGA4EventSender {
  sendEvent(eventName: string, params: {} = {}) {
    // @ts-ignore
    window.dataLayer = window.dataLayer || []
    // @ts-ignore
    window.dataLayer.push({
      event: eventName,
      ...params,
    })
  }

  initIndexPage() {
    this.sendEvent('料金・日時シミュレーション_流入元特定', {
      current_url: window.location.href,
      original_url: document.referrer,
    })
  }

  inputZipFrom(address: YhcZipCodePrefectureType) {
    this.sendEvent('料金・日時シミュレーション_集荷先郵便番号入力', {
      郵便番号: address.zipCode,
      都道府県: address.prefecture,
      対応エリアかどうか: address.areaMessage,
    })
  }

  inputZipTo(address: YhcZipCodePrefectureType) {
    this.sendEvent('料金・日時シミュレーション_お届け先郵便番号入力', {
      郵便番号: address.zipCode,
      都道府県: address.prefecture,
      対応エリアかどうか: address.areaMessage,
    })
  }

  addKazai(kazaiData: YhcEFInputOneKazaiTypeDataObject) {
    this.sendEvent('料金・日時シミュレーション_家財追加', {
      家財名: kazaiData.userInputName
        ? kazaiData.userInputName
        : kazaiData.kazaiType?.name,
    })
  }
  // Web申込ページへ移動
  moveWebApplicationPage() {
    this.sendEvent('料金・日時シミュレーション_Web申込ページへ移動')
  }
  // 旧料金検索ページへ移動
  moveOldSearchPage() {
    this.sendEvent('料金・日時シミュレーション_旧料金検索ページへ移動')
  }
  // SMSクッションページから各リンククリックイベント
  linkClickFromSmsServiceInfoPage(linkName: string) {
    this.sendEvent(`SMS_${linkName}`)
  }
  // ちょこっと模様替え（家具移動オプション）の家財追加イベント
  // 集荷先かお届け先かで分ける
  addKazaiForKaguidoOption(
    kazaiData: YhcEFInputOneKazaiTypeDataObjectForKaguidoOption,
    isFrom: boolean,
  ) {
    this.sendEvent(
      `料金・日時シミュレーション_家財追加_ちょこっと模様替え_${
        isFrom ? '集荷先' : 'お届け先'
      }`,
      {
        家財名: kazaiData.userInputName
          ? kazaiData.userInputName
          : kazaiData.kazaiType?.name,
      },
    )
  }

  // 当日自発着可能エリア
  sameDayDeliveryAvailable(addressFrom: string, addressTo: string) {
    this.sendEvent('料金・日時シミュレーション_当日自発着可能エリア', {
      集荷先郵便番号: addressFrom,
      お届け先郵便番号: addressTo,
    })
  }
  // 当日自発着チェックオン
  checkOnSameDayDelivery() {
    this.sendEvent('料金・日時シミュレーション_当日自発着利用')
  }
}

export const $yhcGA4EventSender = new YhcGA4EventSender()
